import { createContext } from 'react';
import { FieldFilterType } from '@eas/common-web';

export interface DeadlineContextType {
  display: 'IN_ES_FILE' | 'IN_DOCUMENT';
  filtersFields?: FieldFilterType[];
}

export const DeadlineContext = createContext<DeadlineContextType>({} as any);
